import { ticketClient } from "@/api/index";
import { GetTicketItemListReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon } from "@/utils/request";
import { setMetaData } from "@/utils";
//  lee  获取工单分类
interface OrderOptions {
  token: string;
}
export function getOrderOptions(arg: OrderOptions) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetTicketItemListReq();
      request.setCommonin(setCommon());
      request.setIsstage(0);
      await ticketClient.getTicketItemList(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            let res: any = response.toObject();
            let _res: any = {};
            if (!res.commonout || res.commonout.code == 0) {
              let _result =
                typeof res.listList == "object"
                  ? res.listList
                  : JSON.parse(res.listList);
              _res.status = "success";
              _res.data = _result;
            } else {
              _res.status = "error";
              _res.message = res.commonout.errmsg;
            }
            resolve(_res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  });
}
